import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type RegistrationPlacement =
  | 'coming_soon_gate'
  | 'crepe_city_welcome'
  | 'gated_card'
  | 'gated_listing'
  | 'header'
  | 'notify_me'
  | 'profile_page'
  | 'raffle_gate'
  | 'sole_market_buy_now';

export type RegistrationMethod =
  | 'apple'
  | 'email'
  | 'existing_account'
  | 'facebook'
  | 'google';

export type RegistrationElement = 'method' | 'start';

export type RegistrationTargetProperties = {
  element: RegistrationElement;
  method?: RegistrationMethod;
  placement: RegistrationPlacement;
  product_id?: string;
};

type EventData = {
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  method?: RegistrationMethod;
  placement: RegistrationPlacement;
  productId?: string;
};

class RegistrationInteractionEvent extends InteractionEvent<
  EventData,
  RegistrationTargetProperties
> {
  // The header's profile icon is a full page load to /profile/, so the beacon must survive the
  // document unloading.
  protected get keepalive(): boolean {
    return true;
  }

  protected get targetType(): InteractionTargetType {
    return 'registration';
  }

  protected getTargetProperties(): RegistrationTargetProperties {
    return {
      element: this.data.method ? 'method' : 'start',
      method: this.data.method,
      placement: this.data.placement,
      product_id: this.data.productId
    };
  }
}

export default RegistrationInteractionEvent;
